import { render, staticRenderFns } from "./appLibBlackDialog.vue?vue&type=template&id=04e00d57&scoped=true&"
import script from "./appLibBlackDialog.vue?vue&type=script&lang=js&"
export * from "./appLibBlackDialog.vue?vue&type=script&lang=js&"
import style0 from "./appLibBlackDialog.vue?vue&type=style&index=0&id=04e00d57&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e00d57",
  null
  
)

export default component.exports